import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const ExportPriceQuoteDocument = gql`
  mutation ExportPriceQuote(
    $chatId: uuid!
    $priceQuoteId: uuid!
    $fileFormat: ExportFileFormat!
  ) {
    exportPriceQuote(
      chat_id: $chatId
      price_quote_id: $priceQuoteId
      file_format: $fileFormat
    ) {
      document_url
    }
  }
`;
export type ExportPriceQuoteMutationFn = Apollo.MutationFunction<
  Types.ExportPriceQuoteMutation,
  Types.ExportPriceQuoteMutationVariables
>;
export function useExportPriceQuoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ExportPriceQuoteMutation,
    Types.ExportPriceQuoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ExportPriceQuoteMutation,
    Types.ExportPriceQuoteMutationVariables
  >(ExportPriceQuoteDocument, options);
}
export type ExportPriceQuoteMutationHookResult = ReturnType<
  typeof useExportPriceQuoteMutation
>;
export type ExportPriceQuoteMutationResult =
  Apollo.MutationResult<Types.ExportPriceQuoteMutation>;
export type ExportPriceQuoteMutationOptions = Apollo.BaseMutationOptions<
  Types.ExportPriceQuoteMutation,
  Types.ExportPriceQuoteMutationVariables
>;
